import { Component, OnDestroy, OnInit } from '@angular/core';
import { SectionContainerComponent } from '../section-container/section-container.component';
import { SectionHeadingComponent } from '../section-heading/section-heading.component';
import { SectorSectionButtonComponent } from '../sector-section-button/sector-section-button.component';
import { SectorSectionDropdownComponent } from '../sector-section-dropdown/sector-section-dropdown.component';
import { SectionDescriptionComponent } from '../section-description/section-description.component';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { Sector } from '../../../models/sector.model';
import { ToasterService } from '../../../services/toaster.service';
import { Router } from '@angular/router';
import { routes } from '../../../constants/routes';
import { ApiErrorHandler } from '../../../models/api-error-handler.model';
import { apiErrorHandler } from '../../../constants/api-error-handler';

interface IArtifactCount {
  name: string;
  count: number;
}

@Component({
  selector: 'app-explore-by-sector',
  standalone: true,
  imports: [
    SectionContainerComponent,
    SectionHeadingComponent,
    SectionDescriptionComponent,
    SectorSectionButtonComponent,
    SectorSectionDropdownComponent,
  ],
  templateUrl: './explore-by-sector.component.html',
  styleUrl: './explore-by-sector.component.scss',
})
export class ExploreBySectorComponent
  implements OnDestroy, OnInit, ApiErrorHandler
{
  description: string = 'Discover datasets and models for specific sectors';
  artifactCount: IArtifactCount[];
  sectors: Sector[] = [];

  private selectedSectorId: number;

  private fetchArtifactCountSub: Subscription;

  constructor(
    private router: Router,
    private apiService: ApiService,
    public toaster: ToasterService
  ) {}

  ngOnInit(): void {
    this.fetchSectors();
  }

  private fetchSectors() {
    this.apiService.fetchSectors().subscribe({
      next: (sectors) => {
        this.sectors = sectors;
        this.fetchArtifactCountBySector(+sectors[0].id);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  fetchArtifactCountBySector(sectorId: number) {
    this.selectedSectorId = sectorId;
    this.fetchArtifactCountSub = this.apiService
      .fetchArtefactCountBySector(sectorId)
      .subscribe({
        next: (result) => {
          this.artifactCount = [
            { name: 'Datasets', count: result.dataset },
            { name: 'Models', count: result.model },
          ];
        },
        error: apiErrorHandler.bind(this),
      });
  }

  onArtifactSelect(routeTo: string) {
    const fetchSelectedSector = this.sectors.filter(
      (res) => res.id === this.selectedSectorId
    )[0]?.slug;


    this.router.navigate([
      routes.home,
      routeTo.toLocaleLowerCase(),
      this.selectedSectorId
    ]);
  }

  ngOnDestroy() {
    this.fetchArtifactCountSub?.unsubscribe();
  }
}
